import React, { useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { apiUrl } from "../../common/config/apiUrl";

const CommentForm = ({ slug }) => {
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !comment) {
      toast.error("All fields are required!");
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(
        `${apiUrl}comment/store`,
        { name, comment, slug }
      );
      toast.success("Comment submitted successfully!");
      setName("");
      setComment("");
    } catch (error) {
      toast.error("Failed to submit comment. Try again!");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className=" bg-white small:shadow-md rounded-lg small:p-6 p-0 py-2">
      <h3 className="text-xl font-semibold mb-4">Leave a Comment</h3>
      <form onSubmit={handleSubmit} className="space-y-4">
        <input
          type="text"
          placeholder="Your Name"
          className="w-full p-3 border rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-400"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <textarea
          placeholder="Your Comment"
          className="w-full p-3 border rounded-md focus:outline-none focus:ring-1 focus:ring-yellow-400"
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          rows="4"
        ></textarea>
        <div className=" flex justify-center">
        <button
          type="submit"
          className={` small:w-[50%] w-full py-3 text-white rounded-md font-medium transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-yellow-500 hover:bg-yellow-600"
          }`}
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Comment"}
        </button>
        </div>
      </form>
    </div>
  );
};

export default CommentForm;
